import { render, staticRenderFns } from "./order-schedules-grid.vue?vue&type=template&id=01527104&scoped=true"
import script from "./order-schedules-grid.vue?vue&type=script&lang=js"
export * from "./order-schedules-grid.vue?vue&type=script&lang=js"
import style0 from "./order-schedules-grid.vue?vue&type=style&index=0&id=01527104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01527104",
  null
  
)

export default component.exports